import type { GameHarness } from './harness';
import { buildLiveScenario, type LiveChoice } from '../scenarios/live';

export type MenuChoice = LiveChoice;

const MODE_OPTS: [string, string][] = [
  ['free', 'Libre'],
  ['race', 'Course (vs IA)'],
];
const TRACK_OPTS: [string, string][] = [
  ['stadium', 'Stade'],
  ['ring', 'Anneau'],
  ['complex', 'Circuit'],
];
const VEHICLE_OPTS: [string, string][] = [
  ['car', 'Voiture'],
  ['bus', 'Bus'],
];

/** Barre de sélection (HTML) au-dessus du canvas : choisir circuit + véhicule sans URL. */
export function setupMenu(harness: GameHarness, initial: MenuChoice): void {
  const choice: MenuChoice = { ...initial };
  const rebuild = (): void => harness.reset(buildLiveScenario(choice));

  const bar = document.createElement('div');
  bar.style.cssText = [
    'position:fixed',
    'top:10px',
    'left:50%',
    'transform:translateX(-50%)',
    'display:flex',
    'gap:16px',
    'align-items:center',
    'padding:8px 16px',
    'border-radius:12px',
    'background:rgba(12,20,22,0.72)',
    'border:1px solid rgba(255,255,255,0.08)',
    'font-family:system-ui,-apple-system,sans-serif',
    'font-size:13px',
    'color:#d7eee7',
    'box-shadow:0 6px 20px rgba(0,0,0,0.45)',
    'z-index:10',
    'user-select:none',
  ].join(';');

  const makeSelect = (label: string, opts: [string, string][], value: string, onChange: (v: string) => void): HTMLElement => {
    const wrap = document.createElement('label');
    wrap.style.cssText = 'display:flex;gap:7px;align-items:center;cursor:pointer';
    const span = document.createElement('span');
    span.textContent = label;
    span.style.cssText = 'opacity:0.75;letter-spacing:0.3px';
    const sel = document.createElement('select');
    sel.style.cssText =
      'background:#162124;color:#fff;border:1px solid #38484d;border-radius:7px;padding:5px 9px;font-size:13px;cursor:pointer;outline:none';
    for (const [v, txt] of opts) {
      const o = document.createElement('option');
      o.value = v;
      o.textContent = txt;
      if (v === value) o.selected = true;
      sel.appendChild(o);
    }
    sel.addEventListener('change', () => {
      onChange(sel.value);
      sel.blur(); // rend le focus au jeu pour que les flèches conduisent
    });
    wrap.append(span, sel);
    return wrap;
  };

  bar.append(
    makeSelect('🎮 Mode', MODE_OPTS, choice.mode, (v) => {
      choice.mode = v;
      rebuild();
    }),
    makeSelect('🏁 Circuit', TRACK_OPTS, choice.track, (v) => {
      choice.track = v;
      rebuild();
    }),
    makeSelect('🚗 Véhicule', VEHICLE_OPTS, choice.vehicle, (v) => {
      choice.vehicle = v;
      rebuild();
    }),
  );
  document.body.appendChild(bar);
}
